import * as yup from 'yup';

export const magicLinkFormSchema = yup.object().shape({
  email: yup.string().required('Email is required'),
});
